module.exports = __webpack_public_path__ + "img/hal-register.aba3a62d.jpg";